<script>
    import { gameState, switchPage } from "../store";
    import levels from "../levels";

    export let genre;
    export let complexity;
    export let levelNumber;

    function selectLevel(levelNumber) {
        switchPage("GAME_TUTORIAL_PAGE");
        gameState.update((state) => ({
            ...state,
            levelNumber,
            levelProps: levels[genre],
            maxScore: levels[genre].maxScore,
        }));
    }
</script>

<div class="feature-card level" on:click={() => selectLevel(levelNumber)}>
    <h1 class="huge _{levelNumber}">{levelNumber}</h1>
    <div class="heading_wrap">
        <div class="div-block-4">
            <h2 class="heading2">{genre}</h2>
            <h2 class="paragraph level">{complexity}</h2>
        </div>
    </div>
</div>
